import { useId } from 'react';
import './Facet.css';

/**
 * Diamante da marca em traço (o mesmo do logo), desenhado ao entrar na tela.
 * As cópias deslocadas em roxo/ciano repetem a aberração cromática do
 * "SPECTRUM" do logo; o corpo é um preenchimento leve do gradiente.
 *
 * Posição e tamanho ficam com quem usa (className). Ids dos gradientes são
 * únicos por instância: dá para ter mais de um diamante na mesma página.
 */
const FACETS = [
  'M40 12 L160 12 L190 52 L100 168 L10 52 Z', // contorno
  'M10 52 L190 52',                           // cintura
  'M40 12 L58 52 L100 12 L142 52 L160 12',    // coroa
  'M58 52 L100 168 L142 52',                  // pavilhão
];

export default function Facet({ className = '' }) {
  const uid = useId().replace(/:/g, '');
  const grad = `${uid}-stroke`;
  const fill = `${uid}-fill`;

  return (
    <svg className={`brand-facet ${className}`.trim()} viewBox="0 0 200 180" aria-hidden="true" focusable="false">
      <defs>
        <linearGradient id={grad} x1="0" y1="0" x2="1" y2="0.35">
          <stop offset="0" stopColor="#7c3aed" />
          <stop offset="0.45" stopColor="#8b5cf6" />
          <stop offset="0.7" stopColor="#a78bfa" />
          <stop offset="1" stopColor="#22d3ee" />
        </linearGradient>
        <linearGradient id={fill} x1="0" y1="0" x2="0.4" y2="1">
          <stop offset="0" stopColor="#8b5cf6" stopOpacity="0.2" />
          <stop offset="0.75" stopColor="#7c3aed" stopOpacity="0.06" />
          <stop offset="1" stopColor="#22d3ee" stopOpacity="0.03" />
        </linearGradient>
      </defs>
      <path className="brand-facet-body" d={FACETS[0]} fill={`url(#${fill})`} />
      <g className="brand-facet-ghost brand-facet-ghost-p">
        {FACETS.map((d) => <path key={d} d={d} pathLength="1" />)}
      </g>
      <g className="brand-facet-ghost brand-facet-ghost-c">
        {FACETS.map((d) => <path key={d} d={d} pathLength="1" />)}
      </g>
      <g className="brand-facet-main" stroke={`url(#${grad})`}>
        {FACETS.map((d, i) => (
          <path key={d} d={d} pathLength="1" style={{ animationDelay: `${0.15 + i * 0.18}s` }} />
        ))}
      </g>
    </svg>
  );
}
